import { MotionSVG } from '@/components/common/Motion';

const ChartLoading = () => {
    return (
        <MotionSVG
            width="100%"
            height="100%"
            viewBox="0 0 784 215"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            initial={{ opacity: 1 }}
            animate={{ opacity: [0.3, 1] }}
            exit={{
                opacity: 0,
                transition: { duration: 0.5 },
            }}
            // Known typing issue - no problem in operation.
            // Details: https://chakra-ui.com/getting-started/with-framer#chakra-factory
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            transition={{
                duration: 1,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatType: 'reverse',
            }}
        >
            <rect width="24" height="9" rx="4.5" fill="#F6F6F6" />
            <line
                x1="32.5"
                y1="4"
                x2="783.5"
                y2="4"
                stroke="#F6F6F6"
                strokeLinecap="round"
            />
            <rect y="90.5" width="24" height="9" rx="4.5" fill="#F6F6F6" />
            <line
                x1="32.5"
                y1="94.5"
                x2="783.5"
                y2="94.5"
                stroke="#F6F6F6"
                strokeLinecap="round"
            />
            <rect y="181" width="24" height="9" rx="4.5" fill="#F6F6F6" />
            <line
                x1="32.5"
                y1="185"
                x2="783.5"
                y2="185"
                stroke="#F6F6F6"
                strokeLinecap="round"
            />
            <g clipPath="url(#clip0_2972_3)">
                <path
                    d="M79.2273 99.7171L48 72.1515V185H784V52L704.601 105.435C689.112 115.86 669.842 119.001 651.844 114.034L643.349 111.69C638.719 110.412 633.961 109.66 629.163 109.447L603.145 108.292C595.121 107.935 587.237 106.072 579.903 102.799L559.801 93.8287C545.933 87.6402 530.317 86.5844 515.742 90.85L510.62 92.3491C498.74 95.8261 486.106 95.7832 474.25 92.2256L464.043 89.1631C447.808 84.2915 430.304 86.0594 415.37 94.079L352.642 127.765C330.416 139.701 303.252 137.467 283.276 122.059L251.464 97.5232C231.456 82.0917 204.242 79.8763 182.002 91.8684L151.957 108.069C128.357 120.794 99.3277 117.461 79.2273 99.7171Z"
                    fill="url(#paint0_linear_2972_3)"
                />
                <path
                    d="M48 72.1515L79.2273 99.7171C99.3277 117.461 128.357 120.794 151.957 108.069L182.002 91.8684C204.242 79.8763 231.456 82.0917 251.464 97.5232L283.276 122.059C303.252 137.467 330.416 139.701 352.642 127.765L415.37 94.079C430.304 86.0595 447.808 84.2915 464.043 89.1631L474.25 92.2256C486.106 95.7832 498.74 95.8261 510.62 92.3491L515.742 90.85C530.317 86.5844 545.933 87.6402 559.801 93.8287L579.903 102.799C587.237 106.072 595.121 107.935 603.145 108.292L629.163 109.447C633.961 109.66 638.719 110.412 643.349 111.69L651.844 114.034C669.842 119.001 689.112 115.86 704.601 105.435L784 52"
                    stroke="#E4E4E4"
                    strokeWidth="2"
                    strokeDasharray="4 4"
                />
            </g>
            <rect
                x="113.333"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="170.667"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="228"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="285.333"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="342.667"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="400"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="457.333"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="514.667"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="572"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="629.333"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="686.667"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <rect
                x="744"
                y="206"
                width="24"
                height="9"
                rx="4.5"
                fill="#F6F6F6"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2972_3"
                    x1="416"
                    y1="52"
                    x2="416"
                    y2="185"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FAFAFA" />
                    <stop offset="1" stopColor="#FAFAFA" stopOpacity="0" />
                </linearGradient>
                <clipPath id="clip0_2972_3">
                    <rect
                        width="736"
                        height="133"
                        fill="white"
                        transform="translate(48 52)"
                    />
                </clipPath>
            </defs>
        </MotionSVG>
    );
};

export default ChartLoading;
